import createSSCLocale from './create-ssc-locale';

const bn: Record<string, string> = require('./bn_BD.json');

export default createSSCLocale(bn);
